/** @jsx jsx */
import { jsx } from 'theme-ui';
import { CustomSelectField } from './CustomSelectField';
export var CountryDiallingCodeField = function (_a) {
    var variant = _a.variant, className = _a.className, value = _a.value, onChange = _a.onChange;
    return (jsx(CustomSelectField, { variant: variant, className: className, options: codes, value: value, onChange: onChange, placeholder: "Select...", sx: { width: 110 } }));
};
var codes = [
    { value: '1', text: '🇨🇦 +1' },
    { value: '1', text: '🇺🇲 +1' },
    { value: '7', text: '🇷🇺 +7' },
    { value: '20', text: '🇪🇬 +20' },
    { value: '27', text: '🇿🇦 +27' },
    { value: '30', text: '🇬🇷 +30' },
    { value: '31', text: '🇳🇱 +31' },
    { value: '32', text: '🇧🇪 +32' },
    { value: '33', text: '🇫🇷 +33' },
    { value: '34', text: '🇪🇸 +34' },
    { value: '36', text: '🇭🇺 +36' },
    { value: '39', text: '🇮🇹 +39' },
    { value: '40', text: '🇷🇴 +40' },
    { value: '41', text: '🇨🇭 +41' },
    { value: '43', text: '🇦🇹 +43' },
    { value: '44', text: '🇬🇧 +44' },
    { value: '44', text: '🇬🇬 +44' },
    { value: '44', text: '🇮🇲 +44' },
    { value: '44', text: '🇯🇪 +44' },
    { value: '45', text: '🇩🇰 +45' },
    { value: '46', text: '🇸🇪 +46' },
    { value: '47', text: '🇧🇻 +47' },
    { value: '48', text: '🇵🇱 +48' },
    { value: '49', text: '🇩🇪 +49' },
    { value: '51', text: '🇵🇪 +51' },
    { value: '52', text: '🇲🇽 +52' },
    { value: '53', text: '🇨🇺 +53' },
    { value: '54', text: '🇦🇷 +54' },
    { value: '55', text: '🇧🇷 +55' },
    { value: '56', text: '🇨🇱 +56' },
    { value: '57', text: '🇨🇴 +57' },
    { value: '58', text: '🇻🇪 +58' },
    { value: '60', text: '🇲🇾 +60' },
    { value: '61', text: '🇦🇺 +61' },
    { value: '61', text: '🇨🇨 +61' },
    { value: '61', text: '🇨🇽 +61' },
    { value: '61', text: '🇭🇲 +61' },
    { value: '62', text: '🇮🇩 +62' },
    { value: '63', text: '🇵🇭 +63' },
    { value: '64', text: '🇳🇿 +64' },
    { value: '64', text: '🇵🇳 +64' },
    { value: '65', text: '🇸🇬 +65' },
    { value: '66', text: '🇹🇭 +66' },
    { value: '76', text: '🇰🇿 +76' },
    { value: '77', text: '🇰🇿 +77' },
    { value: '81', text: '🇯🇵 +81' },
    { value: '82', text: '🇰🇷 +82' },
    { value: '84', text: '🇻🇳 +84' },
    { value: '86', text: '🇨🇳 +86' },
    { value: '90', text: '🇹🇷 +90' },
    { value: '91', text: '🇮🇳 +91' },
    { value: '92', text: '🇵🇰 +92' },
    { value: '93', text: '🇦🇫 +93' },
    { value: '94', text: '🇱🇰 +94' },
    { value: '95', text: '🇲🇲 +95' },
    { value: '98', text: '🇮🇷 +98' },
    { value: '211', text: '🇸🇸 +211' },
    { value: '212', text: '🇪🇭 +212' },
    { value: '212', text: '🇲🇦 +212' },
    { value: '213', text: '🇩🇿 +213' },
    { value: '216', text: '🇹🇳 +216' },
    { value: '218', text: '🇱🇾 +218' },
    { value: '220', text: '🇬🇲 +220' },
    { value: '221', text: '🇸🇳 +221' },
    { value: '222', text: '🇲🇷 +222' },
    { value: '223', text: '🇲🇱 +223' },
    { value: '224', text: '🇬🇳 +224' },
    { value: '225', text: '🇨🇮 +225' },
    { value: '226', text: '🇧🇫 +226' },
    { value: '227', text: '🇳🇪 +227' },
    { value: '228', text: '🇹🇬 +228' },
    { value: '229', text: '🇧🇯 +229' },
    { value: '230', text: '🇲🇺 +230' },
    { value: '231', text: '🇱🇷 +231' },
    { value: '232', text: '🇸🇱 +232' },
    { value: '233', text: '🇬🇭 +233' },
    { value: '234', text: '🇳🇬 +234' },
    { value: '235', text: '🇹🇩 +235' },
    { value: '236', text: '🇨🇫 +236' },
    { value: '237', text: '🇨🇲 +237' },
    { value: '238', text: '🇨🇻 +238' },
    { value: '239', text: '🇸🇹 +239' },
    { value: '240', text: '🇬🇶 +240' },
    { value: '241', text: '🇬🇦 +241' },
    { value: '242', text: '🇨🇬 +242' },
    { value: '243', text: '🇨🇩 +243' },
    { value: '244', text: '🇦🇴 +244' },
    { value: '245', text: '🇬🇼 +245' },
    { value: '246', text: '🇮🇴 +246' },
    { value: '248', text: '🇸🇨 +248' },
    { value: '249', text: '🇸🇩 +249' },
    { value: '250', text: '🇷🇼 +250' },
    { value: '251', text: '🇪🇹 +251' },
    { value: '252', text: '🇸🇴 +252' },
    { value: '253', text: '🇩🇯 +253' },
    { value: '254', text: '🇰🇪 +254' },
    { value: '255', text: '🇹🇿 +255' },
    { value: '256', text: '🇺🇬 +256' },
    { value: '257', text: '🇧🇮 +257' },
    { value: '258', text: '🇲🇿 +258' },
    { value: '260', text: '🇿🇲 +260' },
    { value: '261', text: '🇲🇬 +261' },
    { value: '262', text: '🇷🇪 +262' },
    { value: '262', text: '🇹🇫 +262' },
    { value: '262', text: '🇾🇹 +262' },
    { value: '263', text: '🇿🇼 +263' },
    { value: '264', text: '🇳🇦 +264' },
    { value: '265', text: '🇲🇼 +265' },
    { value: '266', text: '🇱🇸 +266' },
    { value: '267', text: '🇧🇼 +267' },
    { value: '268', text: '🇸🇿 +268' },
    { value: '269', text: '🇰🇲 +269' },
    { value: '290', text: '🇸🇭 +290' },
    { value: '291', text: '🇪🇷 +291' },
    { value: '297', text: '🇦🇼 +297' },
    { value: '298', text: '🇫🇴 +298' },
    { value: '299', text: '🇬🇱 +299' },
    { value: '350', text: '🇬🇮 +350' },
    { value: '351', text: '🇵🇹 +351' },
    { value: '352', text: '🇱🇺 +352' },
    { value: '353', text: '🇮🇪 +353' },
    { value: '354', text: '🇮🇸 +354' },
    { value: '355', text: '🇦🇱 +355' },
    { value: '356', text: '🇲🇹 +356' },
    { value: '357', text: '🇨🇾 +357' },
    { value: '358', text: '🇦🇽 +358' },
    { value: '358', text: '🇫🇮 +358' },
    { value: '359', text: '🇧🇬 +359' },
    { value: '370', text: '🇱🇹 +370' },
    { value: '371', text: '🇱🇻 +371' },
    { value: '372', text: '🇪🇪 +372' },
    { value: '373', text: '🇲🇩 +373' },
    { value: '374', text: '🇦🇲 +374' },
    { value: '375', text: '🇧🇾 +375' },
    { value: '376', text: '🇦🇩 +376' },
    { value: '377', text: '🇲🇨 +377' },
    { value: '377', text: '🇽🇰 +377' },
    { value: '381', text: '🇽🇰 +381' },
    { value: '383', text: '🇽🇰 +383' },
    { value: '386', text: '🇽🇰 +386' },
    { value: '378', text: '🇸🇲 +378' },
    { value: '379', text: '🇻🇦 +379' },
    { value: '380', text: '🇺🇦 +380' },
    { value: '381', text: '🇷🇸 +381' },
    { value: '382', text: '🇲🇪 +382' },
    { value: '385', text: '🇭🇷 +385' },
    { value: '386', text: '🇸🇮 +386' },
    { value: '387', text: '🇧🇦 +387' },
    { value: '389', text: '🇲🇰 +389' },
    { value: '420', text: '🇨🇿 +420' },
    { value: '421', text: '🇸🇰 +421' },
    { value: '423', text: '🇱🇮 +423' },
    { value: '500', text: '🇫🇰 +500' },
    { value: '500', text: '🇬🇸 +500' },
    { value: '501', text: '🇧🇿 +501' },
    { value: '502', text: '🇬🇹 +502' },
    { value: '503', text: '🇸🇻 +503' },
    { value: '504', text: '🇭🇳 +504' },
    { value: '505', text: '🇳🇮 +505' },
    { value: '506', text: '🇨🇷 +506' },
    { value: '507', text: '🇵🇦 +507' },
    { value: '508', text: '🇵🇲 +508' },
    { value: '509', text: '🇭🇹 +509' },
    { value: '590', text: '🇧🇱 +590' },
    { value: '590', text: '🇬🇵 +590' },
    { value: '590', text: '🇲🇫 +590' },
    { value: '591', text: '🇧🇴 +591' },
    { value: '592', text: '🇬🇾 +592' },
    { value: '593', text: '🇪🇨 +593' },
    { value: '594', text: '🇬🇫 +594' },
    { value: '595', text: '🇵🇾 +595' },
    { value: '596', text: '🇲🇶 +596' },
    { value: '597', text: '🇸🇷 +597' },
    { value: '598', text: '🇺🇾 +598' },
    { value: '670', text: '🇹🇱 +670' },
    { value: '672', text: '🇦🇶 +672' },
    { value: '672', text: '🇳🇫 +672' },
    { value: '673', text: '🇧🇳 +673' },
    { value: '674', text: '🇳🇷 +674' },
    { value: '675', text: '🇵🇬 +675' },
    { value: '676', text: '🇹🇴 +676' },
    { value: '677', text: '🇸🇧 +677' },
    { value: '678', text: '🇻🇺 +678' },
    { value: '679', text: '🇫🇯 +679' },
    { value: '680', text: '🇵🇼 +680' },
    { value: '681', text: '🇼🇫 +681' },
    { value: '682', text: '🇨🇰 +682' },
    { value: '683', text: '🇳🇺 +683' },
    { value: '685', text: '🇼🇸 +685' },
    { value: '686', text: '🇰🇮 +686' },
    { value: '687', text: '🇳🇨 +687' },
    { value: '688', text: '🇹🇻 +688' },
    { value: '689', text: '🇵🇫 +689' },
    { value: '690', text: '🇹🇰 +690' },
    { value: '691', text: '🇫🇲 +691' },
    { value: '692', text: '🇲🇭 +692' },
    { value: '850', text: '🇰🇵 +850' },
    { value: '852', text: '🇭🇰 +852' },
    { value: '853', text: '🇲🇴 +853' },
    { value: '855', text: '🇰🇭 +855' },
    { value: '856', text: '🇱🇦 +856' },
    { value: '880', text: '🇧🇩 +880' },
    { value: '886', text: '🇹🇼 +886' },
    { value: '960', text: '🇲🇻 +960' },
    { value: '961', text: '🇱🇧 +961' },
    { value: '962', text: '🇯🇴 +962' },
    { value: '963', text: '🇸🇾 +963' },
    { value: '964', text: '🇮🇶 +964' },
    { value: '965', text: '🇰🇼 +965' },
    { value: '966', text: '🇸🇦 +966' },
    { value: '967', text: '🇾🇪 +967' },
    { value: '968', text: '🇴🇲 +968' },
    { value: '970', text: '🇵🇸 +970' },
    { value: '971', text: '🇦🇪 +971' },
    { value: '972', text: '🇮🇱 +972' },
    { value: '973', text: '🇧🇭 +973' },
    { value: '974', text: '🇶🇦 +974' },
    { value: '975', text: '🇧🇹 +975' },
    { value: '976', text: '🇲🇳 +976' },
    { value: '977', text: '🇳🇵 +977' },
    { value: '992', text: '🇹🇯 +992' },
    { value: '993', text: '🇹🇲 +993' },
    { value: '994', text: '🇦🇿 +994' },
    { value: '995', text: '🇬🇪 +995' },
    { value: '996', text: '🇰🇬 +996' },
    { value: '998', text: '🇺🇿 +998' },
    { value: '1242', text: '🇧🇸 +1242' },
    { value: '1246', text: '🇧🇧 +1246' },
    { value: '1264', text: '🇦🇮 +1264' },
    { value: '1268', text: '🇦🇬 +1268' },
    { value: '1284', text: '🇻🇬 +1284' },
    { value: '1340', text: '🇻🇮 +1340' },
    { value: '1345', text: '🇰🇾 +1345' },
    { value: '1441', text: '🇧🇲 +1441' },
    { value: '1473', text: '🇬🇩 +1473' },
    { value: '1649', text: '🇹🇨 +1649' },
    { value: '1664', text: '🇲🇸 +1664' },
    { value: '1670', text: '🇲🇵 +1670' },
    { value: '1671', text: '🇬🇺 +1671' },
    { value: '1684', text: '🇦🇸 +1684' },
    { value: '1721', text: '🇸🇽 +1721' },
    { value: '1758', text: '🇱🇨 +1758' },
    { value: '1767', text: '🇩🇲 +1767' },
    { value: '1784', text: '🇻🇨 +1784' },
    { value: '1787', text: '🇵🇷 +1787' },
    { value: '1939', text: '🇵🇷 +1939' },
    { value: '1809', text: '🇩🇴 +1809' },
    { value: '1829', text: '🇩🇴 +1829' },
    { value: '1849', text: '🇩🇴 +1849' },
    { value: '1868', text: '🇹🇹 +1868' },
    { value: '1869', text: '🇰🇳 +1869' },
    { value: '1876', text: '🇯🇲 +1876' },
    { value: '4779', text: '🇸🇯 +4779' },
    { value: '5997', text: '🇧🇶 +5997' },
    { value: '5999', text: '🇨🇼 +5999' },
];
export function getCountryDiallingCode(phone) {
    for (var i = codes.length - 1; i >= 0; i--) {
        if (phone.startsWith('+' + codes[i].value)) {
            return codes[i].value;
        }
    }
    return '44';
}
export function getInternationalPhoneNumber(phone) {
    if (!phone) {
        return { code: '44', number: '' };
    }
    else if (!phone.startsWith('+')) {
        return { code: '44', number: phone };
    }
    else {
        var code = getCountryDiallingCode(phone);
        return { code: code, number: phone.substring(code.length + 1) };
    }
}
//# sourceMappingURL=CountryDiallingCodeField.js.map